/** @format */

import process from "process";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import i18n from "../Langues/i18n";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function createInstanceAndDocsADM(
  instanceNameOrId,
  modelId,
  files,
  token,
  isNewInstance,
  fileJSONs = null,
  iExpectedDocs = null,
  sFinalCustomer,
  ClientId,
  ExistingFinalCustomer
) {
  let instanceId;
  let instanceName;

  // Vérifier si on doit créer une nouvelle instance ou utiliser une existante
  if (isNewInstance) {
    // Créez une nouvelle instance
    const createInstanceResponse = await createInstance(
      instanceNameOrId,
      modelId,
      iExpectedDocs,
      token,
      sFinalCustomer,
      ClientId
    );

    if (createInstanceResponse.statusCode !== 200) {
      throw new Error("Erreur lors de la création de l'instance.");
    }

    instanceId = createInstanceResponse.message.InstanceId;
    instanceName = createInstanceResponse.message.InstanceName;
  } else {
    // Utiliser l'instance existante
    instanceId = instanceNameOrId;

    if (ExistingFinalCustomer !== sFinalCustomer || ExistingFinalCustomer === "multi") {
      updateInstanceDataImportADM(token, instanceId, ClientId, "multi");
    }
  }

  // Upload des documents dans l'instance (nouvelle ou existante)
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileName = file.name;
    const fileType = file.type;

    const createDocsResponse = await createDocs(
      instanceId,
      fileName,
      fileType,
      token,
      fileJSONs[i],
      sFinalCustomer,
      ClientId
    );

    if (createDocsResponse.statusCode === 200) {
      const presignedUrl = createDocsResponse.message.PresignedURL;

      // Upload physique du fichier
      await uploadDoc(file, presignedUrl).then((response) => {});
    } else {
      throw new Error(
        `Erreur lors de la création du document pour le fichier ${fileName}.`
      );
    }
  }

  return { instanceId, instanceName };
}

export async function createInstance(
  instanceName,
  modelId,
  exeptedDocs,
  token,
  sFinalCustomer,
  ClientId
) {
  var instance = instanceName;
  var raw = JSON.stringify({
    ModelId: modelId,
    InstanceName: instance,
    ExpectedDocs: Number(exeptedDocs),
    FinalCustomer: sFinalCustomer,
    Options: {
      OutputAs: "json",
    },
    ClientId: ClientId,
  });

  return await apiRequest(API_BASE_URL + "/admin/process/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: raw,
  });
}

async function createDocs(
  instanceId,
  filename,
  filetype,
  token,
  json = "",
  finalcustomer = "",
  ClientId
) {
  let jsonData;

  try {
    jsonData =
      typeof json === "string" && json.trim() !== "" ? JSON.parse(json) : json;
  } catch (error) {
    console.error("⚠️ Erreur de parsing JSON :", error);
    jsonData = {};
  }

  return await apiRequest(API_BASE_URL + "/admin/document/s3upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      FileName: filename,
      FileType: filetype,
      FinalCustomer: finalcustomer,
      InputData: jsonData,
      ClientId: ClientId,
    }),
  });
}

// Ne pas migrer vers apiRequest : upload direct vers une URL S3 pré-signée,
// pas un appel à ton API Cognito (pas de token, pas de logique 401 pertinente ici).
async function uploadDoc(file, signedUrl) {
  var mypresignedurl = signedUrl;
  var requestOptions = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
      "Content-Length": file.length,
    },
  };

  const response = await fetch(mypresignedurl, requestOptions);
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
}

export async function updateInstanceDataImportADM(
  token,
  instanceId,
  clientID,
  finalCustomer
) {
  const url = API_BASE_URL + "/admin/process/update/";

  const data = await apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      FieldList: {
        sFinalCustomer: finalCustomer,
      },
      ClientId: clientID,
    }),
  });

  toast.success(i18n.t('instanceUpdatedSuccess'));

  return data;
}